var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSound = function SvgSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M19.015 10.368a.7.7 0 0 1 .4.633v12a.7.7 0 0 1-1.143.542l-4.079-3.332H10a.7.7 0 0 1-.7-.7V14.49a.7.7 0 0 1 .7-.7h4.193l4.08-3.33a.7.7 0 0 1 .742-.09m-1 2.108-3.13 2.555a.7.7 0 0 1-.443.158H10.7v3.623l3.742-.001a.7.7 0 0 1 .443.157l3.13 2.557zm4.462 1.71a.7.7 0 0 1 .985.092c1.488 1.796 1.696 4.216.289 6.318a.7.7 0 1 1-1.164-.778c1.056-1.578.898-3.318-.203-4.647a.7.7 0 0 1 .093-.985",
    clipRule: "evenodd"
  })));
};
export default SvgSound;